<template>
  <div class="registro" id="Registro">
    <Volver redireccion="Inicio" />
    <Titulo
      titulo="Registro apoderado(a) para postular en el Sistema de Admisión Escolar"
      subtitulo='Si no tienes RUN chileno, no debes registrarte acá. Obtén tu Identificador Provisorio de Apoderado (IPA) <a href="https://ayudamineduc.cl/tramites-en-linea" target="_blank" style="text-decoration: underline;">aquí</a> <br>
      Completa todos los campos del formulario. <br> Es fundamental que ingreses un correo electrónico y número de teléfono
      válidos y actualizados, ya que serán los medios oficiales para informarte sobre el proceso de postulación
      y los resultados de asignación.'
      tamanioTitulo="h3"
    />
    <b-form @submit.stop.prevent>
      <b-row class="col-12 col-lg-10 px-2 px-lg-5 text-azul mx-auto">
        <b-col
          cols="12"
          class="gilmer h5 font-weight-bold mt-4 text-center text-lg-left"
          >Datos del Apoderado(a)</b-col
        >
        <b-col cols="12" md="3" class="mt-3 borde-grupo">
          <InputTextWrapper
            data-testing="form-run"
            etiqueta="RUN"
            v-model="rut"
            placeholder="21.123.456-1"
            :estado="this.tieneError('run')"
            :mensajeError="this.mensajeError('run')"
            @keyup.once="modificado.push('run')"
            @change="validarRut"
            @keyup="formatoRut"
            maxlength="12"
            prepend="false"
            textInputgroup=""
          />
        </b-col>
        <b-col cols="12" md="5" class="mt-3">
          <label class="mb-1">Fecha de nacimiento</label>
          <div class="form-row">
            <b-col>
              <select
                data-testid="form-fecha-dia"
                class="form-control redondo-derecho"
                id="dia"
                v-model="dia"
                @change="
                  limpiarError('fecha');
                  validarFechaCompleta();
                "
              >
                <option value="null" disabled>Día</option>
                <option :value="dia" v-for="dia in 31" :key="`dia-${dia}`">{{
                  dia
                }}</option>
              </select>
            </b-col>
            <b-col>
              <select
                data-testid="form-fecha-mes"
                class="form-control redondo-derecho"
                id="mes"
                v-model="mes"
                @change="
                  limpiarError('fecha');
                  validarFechaCompleta();
                "
              >
                <option value="null" disabled>Mes</option>
                <option
                  :value="mes.id"
                  v-for="mes in meses"
                  :key="`mes-${mes.id}`"
                  >{{ mes.mes }}</option
                >
              </select>
            </b-col>
            <b-col>
              <select
                data-testid="form-fecha-anio"
                class="form-control redondo-derecho"
                id="anio"
                @change="
                  limpiarError('fecha');
                  validarFechaCompleta();
                "
                v-model="anio"
              >
                <option value="null" disabled>Año</option>
                <option
                  :value="anio"
                  v-for="anio in anios"
                  :key="`anio-${anio}`"
                  >{{ anio }}</option
                >
              </select>
            </b-col>
          </div>
          <span class="mensaje-error">{{ this.mensajeError("fecha") }}</span>
        </b-col>

        <b-col cols="12" md="4" class="mt-3">
          <InputWrapperSerie
            negrita="false"
            grande="false"
            v-model="serie"
            :state="this.tieneError('serie')"
            :mensajeError="this.mensajeError('serie')"
            @keyup.once="modificado.push('serie')"
            @change="validarSerie"
            @keyup="formatoSerie"
          ></InputWrapperSerie>
        </b-col>

        <b-col cols="12" md="6" class="mt-3 borde-grupo ">
          <InputTextWrapper
            data-testing="form-correo-"
            etiqueta="Correo electrónico"
            type="email"
            prepend="true"
            icono="true"
            v-model="form.correoElectronico"
            placeholder="ejemplo@correo.com"
            :estado="this.tieneError('correo')"
            :mensajeError="this.mensajeError('correo')"
            @keyup.once="modificado.push('correo')"
            @change="validarCorreo('correo', form.correoElectronico)"
            maxlength="50"
            onCopy="return false"
            onPaste="return false"
          />
        </b-col>
        <b-col cols="12" md="6" class="mt-3 borde-grupo">
          <InputTextWrapper
            data-testing="form-correo-confirm"
            etiqueta="Confirma correo electrónico"
            type="email"
            prepend="true"
            icono="true"
            v-model="correo2"
            placeholder="ejemplo@correo.com"
            :estado="this.tieneError('correo2')"
            :mensajeError="this.mensajeError('correo2')"
            @keyup.once="modificado.push('correo2')"
            @keyup="validarCorreo('correo2', correo2)"
            maxlength="50"
            onCopy="return false"
            onPaste="return false"
          />
        </b-col>
        <b-col cols="12" md="6" class="mt-3 borde-grupo">
          <InputTextWrapper
            data-testing="form-telefono"
            etiqueta="Número de teléfono móvil"
            prepend="true"
            textInputgroup="+56 9"
            v-model="form.telefonoMovil"
            :estado="this.tieneError('telefono')"
            :mensajeError="this.mensajeError('telefono')"
            @keyup.once="modificado.push('telefono')"
            @change="validarTelefono('telefono', form.telefonoMovil)"
            maxlength="9"
            onCopy="return false"
            onPaste="return false"
          />
        </b-col>
        <b-col cols="12" md="6" class="mt-3 borde-grupo">
          <InputTextWrapper
            data-testing="form-telefono-confirm"
            etiqueta="Confirma tu número de teléfono móvil"
            prepend="true"
            textInputgroup="+56 9"
            v-model="telefono2"
            :estado="this.tieneError('telefono2')"
            :mensajeError="this.mensajeError('telefono2')"
            @keyup.once="modificado.push('telefono2')"
            @keyup="validarTelefono('telefono2', telefono2)"
            maxlength="9"
            onCopy="return false"
            onPaste="return false"
          />
        </b-col>
        <b-col cols="12" md="6" class="mt-3">
          <InputPasswordWrapper
            data-testid="form-password"
            negrita="false"
            grande="false"
            etiqueta="Ingresa una contraseña"
            v-model="form.clave"
            :estado="this.tieneError('password')"
            :mensajeError="this.mensajeError('password')"
            @keyup.once="modificado.push('password')"
            @change="validarPassword('password', form.clave)"
            maxlength="50"
            onCopy="return false"
            onPaste="return false"
          />
        </b-col>
        <b-col cols="12" md="6" class="mt-3">
          <InputPasswordWrapper
            data-testid="form-password-confirm"
            negrita="false"
            grande="false"
            etiqueta="Confirma la contraseña"
            v-model="password2"
            :estado="this.tieneError('password2')"
            :mensajeError="this.mensajeError('password2')"
            @keyup.once="modificado.push('password2')"
            @keyup="validarPassword('password2', password2)"
            maxlength="50"
            onCopy="return false"
            onPaste="return false"
          />
        </b-col>
      </b-row>

      <b-col cols="12" lg="7" class="mx-auto text-azul pt-4">
        <div class="form-check pb-1">
          <label>
            <input
              data-testid="form-check-terminos"
              v-model="terminos"
              @change="validarChecboxes"
              type="checkbox"
              name="radio1"
              id="radio1"
              value="option1"
            />
            <span class="label-text font-weight-bold">
              He leído y acepto
              <a
                href="https://cdnsae.mineduc.cl/docs/Terminos_y_condiciones_sistema_admision.pdf"
                target="_blank"
                data-testid="enlace-descarga-terminos-condiciones"
                class="text-azul-medio subrayado"
                >términos y condiciones</a
              >
              del proceso de admisión
            </span>
          </label>
        </div>
        <div class="form-check pb-1">
          <label>
            <input
              data-testid="form-check-protocolo"
              v-model="protocolo"
              @change="validarChecboxes"
              type="checkbox"
              name="radio2"
              id="radio2"
              value="option1"
            />

            <span class="label-text font-weight-bold">
              He leído y acepto el protocolo de
              <a
                href="https://cdnsae.mineduc.cl/docs/protocolo_de_datos.pdf"
                target="_blank"
                data-testid="enlace-descarga-terminos-condiciones"
                class="text-azul-medio subrayado"
                >manejo de datos</a
              >
            </span>
          </label>
        </div>
        <!--<div class="form-check pb-1">
          <label>
            <input
              data-testid="form-check-requiere"
              v-model="form.requiereInformacionProcesosEspeciales"
              type="checkbox"
              name="radio3"
              id="radio3"
              value="option1"
              @click="
                $ga.event({
                  eventCategory: 'pagina-web-registro',
                  eventAction: 'seleccionar-requiere-informacion-especial',
                  eventLabel: 'seleccionar-requiere-informacion-especial'
                })
              "
            />
            <span class="label-text font-weight-bold">
              Me interesa recibir información de establecimientos que realizarán
              procedimiento especial para alumnos(as) con necesidades educativas
              especiales permanentes
            </span>
          </label>
        </div>-->
        <div v-if="checboxError" class="mensaje-error">
          Para continuar:
          <ul v-if="checboxError">
            <li v-if="!terminos">{{ this.mensajeError("terminos") }}</li>
            <li v-if="!protocolo">{{ this.mensajeError("protocolo") }}</li>
          </ul>
        </div>
      </b-col>
      <b-col cols="12" lg="12" class="text-center mt-4">
        <InvisibleRecaptcha
          v-if="captchaHabilitado"
          id="enviar-form-captcha"
          data-test="button-registrar"
          :sitekey="siteKey"
          :validate="validarFormulario"
          :callback="recaptachaCallback"
          theme="light"
          class="btn btn-lg btn-azul-oscuro2 gilmer text-capitalize px-5 mb-5 font-weight-bold"
          :disabled="false"
          type="submit"
          >Registrarme</InvisibleRecaptcha
        >
        <button
          v-if="!captchaHabilitado"
          data-test="button-registrar"
          id="enviar-form"
          class="btn btn-lg btn-azul-oscuro2 gilmer text-capitalize px-5 font-weight-bold mb-4"
          @click.prevent="pruebaAutomatizada"
        >
          Registrarme
        </button>
      </b-col>
    </b-form>
    <Modal
      v-if="etapaProceso === 'REGISTRO'"
      ref="modalExitoso"
      tituloMensaje="Registro Exitoso"
      mensaje="Ya estás registrado/a, <strong>recuerda que debes postular en la fecha que corresponda.</strong> Mientras tanto, puedes revisar los establecimientos disponibles."
      tipoModal="EXITO"
      destino="Vitrina"
      textoBoton="Ver establecimientos"
    >
    </Modal>
    <Modal
      v-else
      ref="modalExitoso"
      tituloMensaje="Registro Exitoso"
      mensaje="Ya puedes acceder al Sistema de Admisión Escolar."
      destino="Inicio"
      tipoModal="EXITO"
      textoBoton="Iniciar Sesión"
    ></Modal>
    <Modal
      ref="modalApoderadoNoValido"
      tituloMensaje="NO ESTAS VINCULADO(A) A UN ESTUDIANTE."
      mensaje="<span class='text-azul'>
                  Si tienes más de 18 años, solicita la vinculación como apoderado(a) en 
                  <a href='https://www.ayudamineduc.cl/tema/54953#55561' target='_blank' style='text-decoration: underline;  font-weight: bold;'>Ayuda Mineduc.</a>
              </span><br/><br/>
              <span class='text-azul'>
                <strong><i>Mientras gestionas tu solicitud, conoce todos los colegios disponibles a los que puedes postular </i></strong> 
                <br><a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'>VER ESTABLECIMIENTOS</a>
              </span>"
      :ayudaMieduc="false"
      destino="Inicio"
      tipoModal="ALERTA"
      textoBoton="Ir a la página Inicio"
    ></Modal>
  </div>
</template>
<script>
import InputTextWrapper from "@/components/generales/inputs/InputTextWrapper";
import InputPasswordWrapper from "@/components/generales/inputs/InputPasswordWrapper";
import ListaMeses from "@/assets/js/meses";
import FormateaRut from "@/assets/js/formatoRut";
import { manejoErrores } from "@/assets/js/manejoErrores";
import Validador from "@/assets/js/validador";
import { ApiRegistro } from "@/services/ApiRegistro";
import InvisibleRecaptcha from "@/components/generales/recaptcha/InvisibleRecaptcha";
import Modal from "@/components/generales/modales/Mensaje";
import InputWrapperSerie from "@/components/generales/inputs/InputWrapperSerie";
import Volver from "@/components/generales/Volver";
import Titulo from "@/components/generales/TituloRegistro";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faEnvelope);
export default {
  mixins: [manejoErrores],
  components: {
    InputTextWrapper,
    InputPasswordWrapper,
    InvisibleRecaptcha,
    Modal,
    InputWrapperSerie,
    Volver,
    Titulo
  },
  data() {
    return {
      form: {
        run: "",
        digitoVerificador: "",
        fechaDeNacimiento: "",
        cow: "",
        correoElectronico: "",
        telefonoMovil: "",
        clave: "",
        requiereInformacionProcesosEspeciales: false
      },
      config: {
        headers: {},
        params: {}
      },
      rut: "",
      serie: "",
      dia: null,
      mes: null,
      anio: null,
      correo2: "",
      telefono2: "",
      password2: "",
      meses: ListaMeses.meses,
      anios: this.listarAnios(),
      checboxError: false,
      mediosContactoError: false,
      siteKey: RECAPTCHA_PUBLIC_KEY,
      terminos: null,
      protocolo: null,
      tituloMensajeModal: "",
      mensajeModal: "",
      etapaProceso: null,
      tramite: TRAMITE_JULIO, //Borrar propiedad una vez corroborado que el tramite si salio
      captchaHabilitado: localStorage.getItem("recatpchaHabilitado") || "true"
    };
  },
  beforeCreated() {
    const etapaProceso = localStorage.getItem("etapaProceso");
  },
  methods: {
    //ELIMINAR ANTES DE PRODUCCION
    pruebaAutomatizada() {
      let formValido = this.validarFormulario();
      if (formValido) {
        this.config.headers = {
          "g-recaptcha-response": "recaptchaToken"
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        this.form.correoElectronico = this.form.correoElectronico.toLowerCase();
        this.correo2 = this.correo2.toLowerCase();
        this.enviarFormulario();
      }
    },
    //ELIMINAR ANTES DE PRODUCCION
    async recaptachaCallback(recaptchaToken) {
      if (recaptchaToken) {
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        await this.enviarFormulario();
      }
    },
    validarVacio(campo, valor) {
      let valido = true;
      this.limpiarError(campo);
      if (valor.length < 1) {
        this.guardarError(campo, "Campo obligatorio");
        valido = false;
      }
      return valido;
    },
    validarCorreo(campo, valor) {
      let valido = true;
      this.limpiarError(campo);
      if (valor.length >= 1) {
        if (!Validador.validarExpresion("correo", valor)) {
          this.guardarError(campo, "El correo electrónico no es válido");
          valido = false;
        } else if (this.validarMediosContacto()) {
          this.limpiarErroresMediosContacto();
        }
      }
      return valido;
    },
    validarRut() {
      let valido = true;
      let valor = this.rut;
      this.limpiarError("run");
      valido = this.validarVacio("run", valor);
      if (valido) {
        if (
          !Validador.validarExpresion("rut", valor) ||
          !FormateaRut.digitoVerificador(valor)
        ) {
          this.guardarError("run", "El Run no es válido");
          valido = false;
        }
      }
      if (valido) {
        this.form.run = parseInt(
          valor
            .slice(0, -1)
            .split(".")
            .join("")
            .replace("-", "")
        );
        this.form.digitoVerificador = valor.substr(valor.length - 1);
      }
      return valido;
    },
    validarTelefono(campo, valor) {
      let valido = true;
      this.limpiarError(campo);
      if (valor.length >= 1) {
        if (!Validador.validarExpresion("telefono", valor)) {
          this.guardarError(campo, "El número de telefóno no es válido");
          valido = false;
        } else if (Validador.validarExpresion("telefono-longitud", valor)) {
          this.guardarError(
            campo,
            "Debe ingresar sólo los 8 últimos digitos de su teléfono móvil"
          );
          valido = false;
        } else if (this.validarMediosContacto()) {
          this.limpiarErroresMediosContacto();
        }
      }
      return valido;
    },
    validarSerie() {
      let valido = true;
      let valor = this.serie;
      this.limpiarError("serie");
      valido = this.validarVacio("serie", valor);
      if (valido) {
        if (!Validador.validarExpresion("serie", valor)) {
          this.guardarError(
            "serie",
            "El número de serie/documento no es válido"
          );
          valido = false;
        } else {
          this.form.cow = valor.replace(/\./g, "");
        }
      }
      return valido;
    },
    validarPassword(campo, valor) {
      let valido = true;
      let mensaje = "Contraseña no válida: ";
      let errores = [];
      this.limpiarError(campo);
      valido = this.validarVacio(campo, valor);
      if (valido) {
        if (!Validador.validarExpresion("password", valor)) {
          errores.push(
            "La contraseña debe tener mínimo 8 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo. Ejemplo contraseña: Abcdef1#"
          );
          this.guardarError(
            "password",
            "Contraseña no válida: La contraseña debe tener mínimo 8 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo. Ejemplo contraseña: Abcdef1#"
          );
          valido = false;
        }
        if (
          valor.length < 8
            ? errores.push("Debe tener más de 8 caracteres")
            : valido
        );
        if (errores.length > 0) {
          this.guardarError(campo, mensaje + errores[0]);
          valido = false;
        }
      }
      if (valido) {
        valido = this.validarConfirmacion(
          "password",
          "password2",
          this.form.clave,
          this.password2,
          "Las contraseñas ingresadas no coinciden"
        );
      } else {
        this.limpiarErroresMediosContacto();
      }
      return valido;
    },

    validarFechaNacimiento() {
      let valido = true;
      this.limpiarError("fecha");
      valido = this.validarFechaCompleta();
      if (valido) {
        if (!Validador.validarExpresion("fecha", this.form.fechaDeNacimiento)) {
          this.guardarError("fecha", "Fecha no válida");
        }
      }
      return valido;
    },
    validarChecboxes() {
      let valido = true;
      if (!this.terminos) {
        this.guardarError(
          "terminos",
          "Debes aceptar los términos y condiciones del proceso de admisión"
        );
        valido = false;
      }
      if (!this.protocolo) {
        this.guardarError(
          "protocolo",
          "Debes aceptar el protocolo de manejo de datos"
        );
        valido = false;
      }
      if (!valido ? (this.checboxError = true) : (this.checboxError = false));
      return valido;
    },
    validarMediosContacto() {
      this.modificado;
      let valido = true;
      let validoCorreo = true;
      let validoTelefono = true;
      let correo = this.form.correoElectronico.length <= 1;
      let telefono = this.form.telefonoMovil.length <= 1;
      if (correo) {
        this.guardarError(
          "correo",
          "Debes ingresar un correo electrónico válido"
        );
        this.guardarError("correo2", "");
        valido = false;
      } else {
        if (!correo) {
          validoCorreo = this.validarConfirmacion(
            "correo",
            "correo2",
            this.form.correoElectronico,
            this.correo2,
            "Los correos ingresados no coinciden"
          );
        }
        if (!telefono) {
          validoTelefono = this.validarConfirmacion(
            "telefono",
            "telefono2",
            this.form.telefonoMovil,
            this.telefono2,
            "Los números telefónicos ingresados no coinciden"
          );
        }
        valido = validoCorreo && validoTelefono;
      }
      return valido;
    },
    validarFechaCompleta() {
      let valido = true;
      this.limpiarError("fecha");
      if (this.dia === null && this.mes === null && this.anio === null) {
        this.guardarError("fecha", "Campo Obligatorio");
        valido = false;
      } else if (this.dia === null || this.mes === null || this.anio === null) {
        this.guardarError("fecha", "Fecha Incompleta");
        valido = false;
      } else {
        this.form.fechaDeNacimiento = `${
          this.dia < 10 ? "0" + this.dia : this.dia
        }/${this.mes}/${this.anio}`;
      }
      return valido;
    },
    limpiarErroresMediosContacto() {
      this.limpiarError("correo");
      this.limpiarError("telefono");
      this.limpiarError("correo2");
      this.limpiarError("telefono2");
      this.limpiarError("password");
    },
    validarConfirmacion(campo1, campo2, valor1, valor2, mensaje) {
      let valido = true;
      this.limpiarError(campo1);
      this.limpiarError(campo2);
      if (!(valor1 === valor2)) {
        this.guardarError(campo1, "");
        this.guardarError(campo2, mensaje);
        valido = false;
      }
      return valido;
    },
    listarAnios() {
      let lista = [];
      let fecha = new Date();
      for (
        let anio = fecha.getFullYear() - 15;
        anio > fecha.getFullYear() - 90;
        anio--
      ) {
        lista.push(anio);
      }
      return lista;
    },
    formatoRut() {
      this.rut = FormateaRut.formateaRut(this.rut);
    },
    formatoSerie() {
      this.serie = FormateaRut.formatearSerie(this.serie);
    },
    validarFormulario() {
      this.$emit("cargar");
      this.modificado = [
        "run",
        "fecha",
        "serie",
        "correo",
        "correo2",
        "telefono",
        "telefono2",
        "password",
        "password2",
        "terminos",
        "protocolo"
      ];
      let valido = [
        this.validarRut(),
        this.validarSerie(),
        this.validarPassword("password", this.form.clave),
        this.validarPassword("password2", this.password2),
        this.validarFechaNacimiento(),
        this.validarChecboxes(),
        this.validarMediosContacto()
      ];
      let validado = true;
      if (valido.includes(false)) {
        validado = false;
      }
      this.$emit("cargado");
      return validado;
    },
    async enviarFormulario() {
      this.pendiente = 0;
      let reg = await ApiRegistro.registrarUsuario(
        this.form,
        this,
        this.config
      );
      if (reg) {
        this.consultarEstado(reg);
      } else {
        this.$emit("cargado");
      }
    },
    async consultarEstado(id) {
      let cuenta = await ApiRegistro.consultarEstado(id, this);
      if (cuenta) {
        setTimeout(() => {
          this.informacionEstadoCuenta(cuenta.estado, id);
        }, 2000);
      } else {
        this.$emit("cargado");
      }
    },
    informacionEstadoCuenta(estado, id) {
      let message = "";
      switch (estado) {
        case "APROBADA":
          this.$refs.modalExitoso.showModal();
          this.$emit("cargado");
          break;
        case "RECHAZADA_FECHA_NACIMIENTO":
          message =
            "Los datos que has ingresado no concuerdan con nuestros registros.";
          this.$emit("cargado");
          this.$emit("onAlerta", message, "Datos Incorrectos");
          break;
        case "RECHAZADA_NO_POSTULANTES":
          this.$emit("cargado");
          this.$refs.modalApoderadoNoValido.showModal();
          break;
        case "RECHAZADA_COW":
          message =
            "Los datos que has ingresado no concuerdan con nuestros registros.";
          this.$emit("cargado");
          this.$emit("onError", message, "Datos incorrectos");
          break;
        case "COW_SIN_VALIDAR":
          this.$refs.modalExitoso.showModal();
          this.$emit("cargado");
          break;
        case "PENDIENTE":
          setTimeout(() => {
            this.consultarEstado(id);
          }, 2000);
          break;
      }
    }
  }
};
</script>

<style scoped>
.mensaje-error {
  font-size: 80%;
  color: #dc3545;
}

.registro {
  background-color: #c8c9ee;
}
</style>



// WEBPACK FOOTER //
// src/pages/Registro.vue